<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="fas fa-poll" class="q-mb-sm" /> {{ $t('drills') }}
        </div>

        <q-table
            :data="drills"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            >

            <template slot="top" slot-scope="props" :props="props">
                <div class="col" />

                <q-btn color="secondary" icon="fas fa-plus" :label="$t('new')" @click="$router.push({ name: 'admin_drill', params: { id: 0 } })" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props" v-show="col.show">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props" v-show="showColumn(props.colsMap, 'id')">
                    {{ props.row.id }}
                </q-td>

                <q-td key="title" :props="props" v-show="showColumn(props.colsMap, 'title')">
                    {{ props.row.title }}
                </q-td>

                <q-td key="qty_questions" :props="props" v-show="showColumn(props.colsMap, 'qty_questions')">
                    {{ props.row.qty_questions }}
                </q-td>

                <q-td key="score" :props="props" auto-width v-show="showColumn(props.colsMap, 'score')">
                    {{ props.row.score ? props.row.score.toFixed(2) : '' }}
                </q-td>

                <q-td key="show_feedback" :props="props" auto-width v-show="showColumn(props.colsMap, 'show_feedback')">
                    {{ props.row.show_feedback ?  $t('yes') : $t('no') }}
                </q-td>

                <q-td key="is_mandatory" :props="props" auto-width v-show="showColumn(props.colsMap, 'is_mandatory')">
                    {{ props.row.is_mandatory ? $t('mandatory') : $t('optional')}}
                </q-td>

                <q-td key="publish_date" :props="props" v-show="showColumn(props.colsMap, 'publish_date')">
                    {{ fDate(props.row.publish_date) }}
                </q-td>

                <q-td key="unpublish_date" :props="props" v-show="showColumn(props.colsMap, 'unpublish_date')">
                    {{ fDate(props.row.unpublish_date) }}
                </q-td>

                <q-td key="status" :props="props" auto-width v-show="showColumn(props.colsMap, 'status')">
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props" v-show="showColumn(props.colsMap, 'actions')">
                    <q-btn flat round color="primary" icon="fas fa-pencil-alt" @click="$router.push({ name: 'admin_drill', params: { id: props.row.actions } })" >
                        <q-tooltip>
                            {{ $t('view_or_edit_tooltip')}}
                        </q-tooltip>
                    </q-btn>

                    <q-btn flat round color="secondary" icon="fas fa-chart-line" @click="showReport(props.row)" >
                        <q-tooltip>
                            {{ $t('view_report_for_this_drill_tooltip')}}
                        </q-tooltip>
                    </q-btn>

                    <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" >
                        <q-tooltip>
                            {{ $t('delete_tooltip')}}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
            <q-tr slot="bottom-row" slot-scope="props" :props="props">
				<q-td colspan="100%">
					<q-btn
						flat
						round
						dense
						color="secondary"
						size="small"
						icon="fas fa-cog"
						@click="show_customize_columns = true"
					>
						<q-tooltip>
							{{ $t('configure_table_tooltip') }}
						</q-tooltip>
					</q-btn>
				</q-td>
			</q-tr>
        </q-table>

        <q-dialog v-model="confirm_remove" @ok="removeItem">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props" :props="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
            </template>
        </q-dialog>

        <q-modal
			v-model="show_customize_columns"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="saveColumns()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('personalize_columns') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-md">
						<div
							class="col-xs-12 col-sm-4"
							v-for="(column, index) in columns"
							:key="index"
							v-if="column.label && column.label != '#'"
						>
							<q-checkbox
								v-model="column.show"
								:label="$t(column.label)"
							/>
						</div>
					</div>

					<div class="row reverse gutter-md q-mt-md">
						<div class="col-xs-12 col-sm-3">
							<q-btn
								icon="fas fa-times"
								color="primary"
								class="fit"
								:label="$t('close')"
								@click="saveColumns()"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

        <report :show_report_drill="show_report_drill" :id="id" :title="title" @hide_report="hideReport" />
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import Report from 'components/admin/drills/Report'
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    i18nOptions: { namespaces: [ "custom", "drill", "admin", "common", "users"] },

    components: {
        'report': Report
    },

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            loading: false,
            drills: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'center',
                    field: 'name',
                    show: true,
                    sortable: true,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    show: true,
                    sortable: true,
                },
                {
                    name: 'qty_questions',
                    required: true,
                    label: 'questions_quantity',
                    align: 'left',
                    field: 'qty_questions',
                    show: true,
                    sortable: true,
                },                
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    show: false,
                    sortable: false,
                },
                {
                    name: 'show_feedback',
                    required: true,
                    label: 'show_feedback',
                    align: 'left',
                    field: 'show_feedback',
                    show: false,
                    sortable: false,
                },
                {
                    name: 'is_mandatory',
                    required: true,
                    label: 'mandatory',
                    align: 'left',
                    field: 'mandatory',
                    show: false, //false
                    sortable: false,
                },
                {
                    name: 'publish_date',
                    required: true,
                    label: 'publish_date',
                    align: 'left',
                    field: 'publish_date',
                    show: true,
                    sortable: true,
                },
                {
                    name: 'unpublish_date',
                    required: true,
                    label: 'unpublish_date',
                    align: 'left',
                    field: 'unpublish_date',
                    show: true,
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    show: true,
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    show: true,
                    sortable: false,
                },
            ],
            action_id: '',
            show_customize_columns: false,
            confirm_remove: false,
            show_report_drill: false,
            id: '',
            title: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            user_clients: 'common/user_clients',
            areas: 'registration_lists/country_areas',
            user_groups: 'registration_lists/group_users',
            profiles: 'registration_lists/profiles',
            tags: 'registration_lists/tags',
            reports: 'registration_lists/reports',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        request ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_drills/drills/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.drills = response.data.results.map(r => {
                    return {
                        ...r, actions: r.id,
                    }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        fetchLists() {
            this.$q.loading.show()

            this.$axios.get('/accounts/get_registration_lists/', this.getHeader)
            .then(response => {
                this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
                this.$q.loading.hide()
                this.request({
                    pagination: this.server_pagination
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeItem() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_drills/drills/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.request({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        showReport(drill) {
            this.id = drill.id
            this.title = drill.title
            this.show_report_drill = true
        },

        hideReport() {
            this.show_report_drill = false
            this.id = ''
            this.title = ''
        },

        getStatus(status) {
            if (status == 1) return 'published_f'
            else if (status == 2) return 'unpublished_f'
            else if (status == 3) return 'deleted_f'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
        },

        fDate(d) {
            if (d) return moment(d).tz('Etc/GMT').format('DD/MM/YYYY')
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },
        
        saveDatatableColumns() {
			this.$store.dispatch('datatable_columns/SET_DRILLS_COLUMNS', [this.columns])
		},

        showColumn(list, name) {
			if (list[name]) return list[name].show
			else return false
		},

        saveColumns() {
			this.show_customize_columns = false
			this.saveDatatableColumns()
		},

        loadDatatableColumns() {
			if (this.$compareStoredColumns(this.columns, this.drills_columns))
				this.columns = this.drills_columns
			else return
		},

        getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

        getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
    },

    created() {
        this.loadPagination()
        this.loadDatatableColumns()
        this.fetchLists()
    }
}
</script>

<style lang="stylus" scoped>

</style>
